import { Events, dispatch } from "../redux/dispatch";

import { useApi } from "./useApi";
import { unixTimestamp } from "../utils";

export const useUsers = () => {
  const { client } = useApi();
  const notifyError = (message = "Algo salió mal, intenta más tarde.") => {
    dispatch(Events.SHOW_ALERT, {
      message,
      type: "ERROR",
    });
  };

  const getUser = async () => {
    try {
      const user = await client.get("/v1/users");
      dispatch(Events.SET_USER, {
        ...user,
        lastUpdate: unixTimestamp(),
      });
    } catch (err) {
      notifyError("No fue posible obtener tu perfil.");
    }
  };

  const getUsersStatus = async () => {
    try {
      const users = await client.get("/v1/users/status");
      dispatch(Events.SET_USERS_STATUS, users);
    } catch (err) {
      notifyError("No fue posible obtener la lista de usuarios.");
    }
  };

  const updateUserStatus = async (uid, action) => {
    try {
      await client.patch("/v1/users/status", {
        uid,
        action,
      });

      await getUsersStatus();
    } catch (err) {
      notifyError("No fue posible actualizar el estado del usuario.");
    }
  };

  const createUser = async (name, code, token) => {
    try {
      const body = {
        name,
        code,
      };
      await client.post("/v1/users", body, {
        token,
        userStatus: "NEW",
      });
    } catch (err) {
      notifyError("No fue posible crear el usuario.");
    }
  };

  const deleteUser = async (uid) => {
    try {
      await client.delete(`/v1/users/${uid}`);
    } catch (err) {
      notifyError("No fue posible eliminar el usuario.");
    }
  };

  const updateUserAdmin = async (uid, action) => {
    try {
      await client.patch("/v1/users/admin", {
        uid,
        action,
      });

      await getUsersStatus();
    } catch (err) {
      notifyError("No fue posible actualizar permisos de administrador.");
    }
  };

  const updateUserProfile = async (image, name) => {
    try {
      await client.patch("/v1/users/profile", {
        image,
        name,
      });
      dispatch(Events.SET_IS_LOADING, true);
      setTimeout(async () => {
        await getUser();
        return true;
      }, 1000);
    } catch (err) {
      notifyError("No fue posible actualizar el perfil.");
    }
  };

  return {
    createUser,
    getUser,
    getUsersStatus,
    updateUserStatus,
    updateUserAdmin,
    updateUserProfile,
    deleteUser,
  };
};
